import { useBuildingBlockStore, type BuildingBlockDto } from '@/stores/buildingBlock'
import { useQuantityBuildingBlockStore } from '@/stores/quantityBuildingBlock'
import { useTransportConfigStore } from '@/stores/transportConfig'

export function useBuildingBlockDeletion() {
  const buildingBlockStore = useBuildingBlockStore()
  const quantityBuildingBlockStore = useQuantityBuildingBlockStore()
  const transportConfigStore = useTransportConfigStore()

  const detachBlockReferences = async (blockId: number) => {
    for (const quantity of quantityBuildingBlockStore.items) {
      if (quantity.building_block === blockId) {
        await quantityBuildingBlockStore.update({
          ...quantity,
          building_block: null,
          unit_mismatch_accepted_key: null
        })
      }
    }

    for (const config of transportConfigStore.items) {
      if (config.building_block === blockId && !config.apply_to_all_building_block) {
        await transportConfigStore.delete(config)
      }
    }
  }

  const refetchAfterDeletion = async (calculationId: number) => {
    await Promise.all([
      quantityBuildingBlockStore.fetchItems({ calculation: calculationId }),
      transportConfigStore.fetchItems?.({ calculation: calculationId }),
      buildingBlockStore.fetchItems({ calculation: calculationId })
    ])
  }

  const deleteBuildingBlock = async (block: BuildingBlockDto, calculationId: number) => {
    await detachBlockReferences(block.id)
    await buildingBlockStore.delete(block)
    await refetchAfterDeletion(calculationId)
  }

  return { detachBlockReferences, refetchAfterDeletion, deleteBuildingBlock }
}
